var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
      [
        _c("c-tab", {
          attrs: {
            dense: true,
            tabItems: _vm.tabItems,
            inlineLabel: true,
            height: "900px",
          },
          on: {
            "update:tabItems": function ($event) {
              _vm.tabItems = $event
            },
            "update:tab-items": function ($event) {
              _vm.tabItems = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (tab) {
                return [
                  _c(tab.component, {
                    tag: "component",
                    attrs: { eduCourseId: _vm.popupParam.eduCourseId },
                    on: {
                      "update:eduCourseId": function ($event) {
                        return _vm.$set(_vm.popupParam, "eduCourseId", $event)
                      },
                      "update:edu-course-id": function ($event) {
                        return _vm.$set(_vm.popupParam, "eduCourseId", $event)
                      },
                      saveInfoEvt: _vm.changeStatus,
                    },
                  }),
                ]
              },
            },
          ]),
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }